import { onBeforeUnmount, onMounted, ref } from 'vue';

export function useOrientation() {
  const isPortrait = ref(false);

  let mediaQuery: MediaQueryList | null = null;

  const update = () => {
    isPortrait.value = window.matchMedia('(orientation: portrait)').matches;
  };

  const handleChange = () => {
    update();
  };

  onMounted(() => {
    mediaQuery = window.matchMedia('(orientation: portrait)');
    update();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      // older Safari: MediaQueryList only had addListener/removeListener
      mediaQuery.addListener(handleChange);
    }
  });

  onBeforeUnmount(() => {
    if (!mediaQuery) return;

    if (typeof mediaQuery.removeEventListener === 'function') {
      mediaQuery.removeEventListener('change', handleChange);
    } else {
      mediaQuery.removeListener(handleChange);
    }
  });

  return {
    isPortrait,
  };
}
